import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Login from "../pages/AuthScreens/Login/Login";
import { NavigationRoutes } from "./NavigationRoutes";
import AuthLayout from "../layout/UnAuthLayout/UnAuthLayout";
import ForgotPassword from "../pages/AuthScreens/ForgotPassword/ForgotPassword";
import OtpVerification from "@Pages/AuthScreens/Otp/OtpVerification";
import ResetPassword from "@Pages/AuthScreens/ResetPassword/ResetPassword";
import { APP_NAME } from "@Constants/app";

const RouteList = [
  {
    path: NavigationRoutes.AUTH_ROUTES.LOGIN,
    component: Login,
  },
  {
    path: NavigationRoutes.AUTH_ROUTES.FORGOT_PASSWORD,
    component: ForgotPassword,
  },
  {
    path: NavigationRoutes.AUTH_ROUTES.OTP_VERIFICATION,
    component: OtpVerification,
  },
  {
    path: NavigationRoutes.AUTH_ROUTES.RESET_PASSWORD,
    component: ResetPassword,
  },
];

type UnAuthenticatedProps = {
  allowAllRoutes?: boolean;
};

const UnAuthenticated = ({ allowAllRoutes = false }: UnAuthenticatedProps) => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const unauthPaths = [
      NavigationRoutes.AUTH_ROUTES.LOGIN,
      NavigationRoutes.AUTH_ROUTES.FORGOT_PASSWORD,
      NavigationRoutes.AUTH_ROUTES.OTP_VERIFICATION,
      NavigationRoutes.AUTH_ROUTES.RESET_PASSWORD,
      NavigationRoutes.AUTH_ROUTES.INDEX,
    ];
    if (!unauthPaths.includes(path)) return;

    let moduleTitle = "Login";
    if (path === NavigationRoutes.AUTH_ROUTES.LOGIN || path === "/") {
      moduleTitle = "Login";
    } else if (path === NavigationRoutes.AUTH_ROUTES.FORGOT_PASSWORD) {
      moduleTitle = "Forgot Password";
    } else if (path === NavigationRoutes.AUTH_ROUTES.OTP_VERIFICATION) {
      moduleTitle = "OTP Verification";
    } else if (path === NavigationRoutes.AUTH_ROUTES.RESET_PASSWORD) {
      moduleTitle = "Reset Password";
    }
    document.title = `${moduleTitle} - ${APP_NAME}`;
  }, [location.pathname]);

  return (
    <Routes>
      <Route path={NavigationRoutes.AUTH_ROUTES.INDEX} element={<AuthLayout />}>
        <Route
          path={NavigationRoutes.AUTH_ROUTES.INDEX}
          element={<Navigate to={NavigationRoutes.AUTH_ROUTES.LOGIN} />}
        />
        {RouteList.map(({ path, component: Component }, index) => (
          <Route key={index} path={path} element={<Component />} />
        ))}
      </Route>
      {!allowAllRoutes && (
        <Route
          path="*"
          element={<Navigate to={NavigationRoutes.AUTH_ROUTES.LOGIN} />}
        />
      )}
    </Routes>
  );
};

export default UnAuthenticated;
